import * as loginApi from './loginApi';
import * as loginActions from './loginActions';

export function loginUser(user, cb) {
  return (dispatch) => {
    loginApi
      .loginUser(user)
      .then((response) => {
        if (response && response.data && response.data.length > 0) {
          dispatch(loginActions.loginUser(response.data[0]));
          cb();
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/login/loginServices.js